export default "__VITE_ASSET__ClBj0sE1__"